export var IdMissingResourceTypes;
(function (IdMissingResourceTypes) {
    IdMissingResourceTypes["Gold"] = "Gold";
    IdMissingResourceTypes["Dollar"] = "Dollar";
    IdMissingResourceTypes["Resources"] = "Resources";
    IdMissingResourceTypes["ShopMaterials"] = "ShopMaterials";
    IdMissingResourceTypes["NonBuyable"] = "NonBuyable";
    IdMissingResourceTypes["TournamentCoins"] = "TournamentCoins";
})(IdMissingResourceTypes || (IdMissingResourceTypes = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/IdMissingResourceTypes.ts
// module id = 95
// module chunks = 3